module.exports = __webpack_public_path__ + "static/meeting-54cb601b3978869e83d35ff1b4491e2f.jpg";